function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="40" height="40" viewBox="0 0 40 40" {...props}><path fill="#7F8FA4" d="M23.44 26.17l2.16-11.52-5.96 7.85 1.75 2.33 1.16 1.55a.5.5 0 0 0 .51.19.5.5 0 0 0 .38-.4zm-4.64-.15l1.47-1-1.5-2.02H18v2.6c0 .2.1.36.27.45a.5.5 0 0 0 .52-.03zM14 22h4.77l5.88-7.74-10.91 6.82a.5.5 0 0 0-.22.56.5.5 0 0 0 .48.36zm12-8.64c.46.34.69.9.58 1.47l-2.16 11.53a1.5 1.5 0 0 1-2.67.62l-.88-1.17-1.51 1.04A1.5 1.5 0 0 1 17 25.6V23H14a1.5 1.5 0 0 1-1.44-1.09 1.5 1.5 0 0 1 .65-1.68l11.1-6.95a1.5 1.5 0 0 1 1.65.04l.02.01s0 .02.02.03z" fillRule="evenodd" /></svg>;
});


// WEBPACK FOOTER //
// ./media/svg/mail-use.svg